// @ts-nocheck
// TODO: tighten types after migration
import React from "react";
import "./SharePost.css";
import { getBlogPostUrlFromParts } from "../utils/blogRoutes";
import useCopyFeedback from "../hooks/useCopyFeedback";

const ShareButtons = ({ title, slug, category }) => {
    const pageUrl = getBlogPostUrlFromParts(slug, category);
    void title;
    const { isCopied: copied, copyText } = useCopyFeedback({ resetDelayMs: 1500 });

    const handleCopy = async () => {
        await copyText(pageUrl);
    };

    return (
      <div className="share-copy-link flex items-center justify-end leading-[1] max-[1024px]:justify-start">
          <button className="link-button group flex h-auto cursor-pointer items-center justify-center gap-[5px] border-none bg-transparent p-0 text-inherit font-inherit transition-none appearance-none" onClick={handleCopy} aria-label="Copy Link">
                  {copied ? (
                      <>
                          <i className="fi fi-sr-check text-[1.1em] text-[#47b5ff]"></i>
                          <span className="copied-text flex items-center justify-center text-[0.9em] text-[#47b5ff]">Copied!</span>
                      </>
                  ) : (
                      <>
                          <i className="fi fi-sc-link-alt text-[1.1em] text-text transition-transform duration-200 group-hover:scale-105 group-hover:text-[#47b5ff]"></i>
                          <span className="copy-text flex items-center justify-center text-[0.9em] text-text transition-transform duration-200 group-hover:scale-105 group-hover:text-[#47b5ff]">Copy</span>
                      </>
                  )}
              </button>
      </div>
    );
};

export default ShareButtons;
